module.exports = __webpack_public_path__ + "img/icon_yjh.d32a0815.png";